/** Canonical public origin. Every absolute NeoProf URL is built from it. */
export const SITE_ORIGIN = 'https://www.neoprof.fr';
export const SITE_BRAND = 'NeoProf';
/** The developer every NeoProf product credits (CALC5 R2). */
export const AUTHOR = 'Mahmoud Tulaimat';
export const CONTACT_EMAIL = 'mahmoud.tulaimat@gmail.com';

export const absoluteSiteUrl = (pathname) => new URL(pathname, SITE_ORIGIN).toString();
